import { ApplicationConfig, EnvironmentProviders, APP_INITIALIZER, PLATFORM_ID, importProvidersFrom, isDevMode, makeEnvironmentProviders } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { DndModule } from 'ngx-drag-drop';
import { StoreModule } from '@ngrx/store';
import { catalogReducer } from './core/store/catalog.reducer';
import { profilesReducer } from './core/store/profiles/profiles.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CatalogEffects } from './core/store/catalog.effects';
import { ProfileEffects } from './core/store/profiles/profiles.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { TokenInterceptor } from './core/interceptors/token/token-interceptor';
import { TokenExpirationInterceptor } from './core/interceptors/token/token-expiration-interceptor';
import { mixpanelAppInitializer } from './core/services/mixpanel/mixpanel-app-initializer';
import { notificationsAppInitializer } from './core/services/notifications/notifications-app-initializer';
import { LocalStorageService } from './core/services/local-storage/local-storage.service';
import { NotificationsService } from './core/services/notifications/notifications.service';
import { WINDOW_PROVIDER } from './core/providers/window.provider';

const SHARED_PROVIDERS: EnvironmentProviders[] = [
  importProvidersFrom(
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    DndModule,
    StoreModule.forRoot({
      catalog: catalogReducer,
      profiles: profilesReducer,
    }),
    EffectsModule.forRoot([CatalogEffects, ProfileEffects])
  ),
  makeEnvironmentProviders([
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenExpirationInterceptor, multi: true },
    WINDOW_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: mixpanelAppInitializer,
      deps: [LocalStorageService, PLATFORM_ID],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: notificationsAppInitializer,
      deps: [NotificationsService],
      multi: true,
    },
  ]),
  provideHttpClient(withInterceptorsFromDi()),
];

export const appConfig: ApplicationConfig = {
  providers: [
    ...SHARED_PROVIDERS,
    provideClientHydration(),
    importProvidersFrom(
      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: !isDevMode(),
        connectInZone: true,
      }),
    ),
    provideAnimations(),
  ],
};

export { SHARED_PROVIDERS };
